import styled from "styled-components";
import { TEXT_PRIMARY } from "@streeteasy/design-system/colors";

import { smallScreen } from "src/shared/constants/screenSizes";

export const RoomInfoContainer = styled.ul`
  align-items: center;
  display: flex;
  padding: 3px 0;
`;

export const RoomInfoItem = styled.li`
  align-items: center;
  display: flex;
  height: 17px;

  &:first-child {
    padding-left: 0;
  }

  &:not(:last-child) {
    border-right: 1px solid rgba(151, 151, 151, 0.5);
  }

  @media screen and (max-width: ${smallScreen}px) {
    display: ${({ squareFootage }) => (squareFootage ? "none" : "flex")};

    &:nth-child(2) {
      border-right: 0;
    }
  }

  padding: 0 14px;
  white-space: nowrap;
`;

export const RoomInfoText = styled.p`
  color: ${TEXT_PRIMARY};
  font-size: 14px;
  line-height: 18px;
  margin: 0;

  &:last-child {
    line-height: initial;
  }
`;
